module.exports = __webpack_public_path__ + "media/images/icon/icons8-Private-c3d52f54b15ab8a751d07946261dd118.png";